import { render, staticRenderFns } from "./suorite.vue?vue&type=template&id=4d8b018a&scoped=true&"
import script from "./suorite.vue?vue&type=script&lang=ts&"
export * from "./suorite.vue?vue&type=script&lang=ts&"
import style0 from "./suorite.vue?vue&type=style&index=0&id=4d8b018a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b018a",
  null
  
)

export default component.exports